module.exports = __webpack_public_path__ + "fc08a3cde905ee9f21c62fcba5a3e990.legend.png";


//////////////////
// WEBPACK FOOTER
// ./components/productVariants/rankPickers/mobileLegends/assets/legend.png
// module id = URzQ
// module chunks = 0